<span 
    *ngIf="status"
    [title]="status.nome"
    class="sgt-cliente-analise-mercado-revisao-status-badge badge"
    [ngStyle]="{
        'background-color': status.backgroundColor,
        'color': status.color,
        'border-width': '1px',
        'border-style': 'solid', 
        'border-color': status.color,            
        'font-size': styles.fontSize
    }">
    {{status.nome}}
</span>
